<div class="card">
  <div>
    <table class="margin-bottom">
      @if (productDetailService.parameters?.length) {
        <tbody>
          @for (param of productDetailService.parameters; track param) {
            <tr>
              <td class="">
                {{ param.parameter.name }}
              </td>
              <td class="">
                @if (param.parameter.type === 'enum') {
                  <form-row-select
                    [inputDisabled]="productDetailService.loading"
                    [options]="getOptionsForEnum(param)"
                    [(model)]="param.value"
                    [noMarginBottom]="true"
                    [dataCyAttribute]="'product-parameter-enum'"
                  ></form-row-select>
                }
                @if (param.parameter.type === 'enum_multi') {
                  <form-row-select-multiple
                    [inputDisabled]="productDetailService.loading"
                    [options]="param.parameter.enumValues"
                    [(selectedValues)]="param.value"
                    [dataCyAttribute]="'product-parameter-enum-multi'"
                    [noMarginBottom]="true"
                  ></form-row-select-multiple>
                }
                @if (param.parameter.type === 'text' || param.parameter.type === 'number') {
                  <form-row-input
                    [inputDisabled]="productDetailService.loading"
                    [inputType]="param.parameter.type === 'text' ? 'text' : 'number'"
                    [(model)]="param.value"
                    [noMarginBottom]="true"
                    [dataCyAttribute]="'product-parameter-string'"
                  ></form-row-input>
                }
                @if (param.parameter.type === 'boolean') {
                  <form-row-select
                    [inputDisabled]="productDetailService.loading"
                    [options]="isTrueFalseOptions"
                    [(model)]="param.value"
                    [noMarginBottom]="true"
                    [dataCyAttribute]="'product-parameter-boolean'"
                  ></form-row-select>
                }
              </td>
              <td class="">
                {{ param.parameter.unit }}
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
    @if (!productDetailService.parameters || productDetailService.parameters?.length === 0) {
      <div class="col-12">
        <div class="row">
          <div class="col-12 d-flex justify-content-center">
            <p class="m-0">
              {{ 'product-parameters.no-params.1' | translate }}
              <a [routerLink]="['/parameters']">{{ 'product-parameters.no-params.2' | translate }}</a
              >.
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
